import Button from "@/components/Button";
import usePage from "@/hooks/use-page";
import { useNavigate } from '@/lib/router-dom';
import "@/translations/i18n";
import { useTranslation } from "react-i18next";
import rem from '@/utils/rem';
import PropTypes from 'prop-types';
import {ReactComponent as SuccessLayoutSvg} from '@/assets/svgs/success-screen.svg'

const ResultPage = ({
	defaultTitle,
	breadcrumbs,
	layoutHeaderTxt,
	layoutSubHeaderTxt,
	backBtnTxt,
	nextLocation,
	translationCheck = true,
	viewRecordLocation,
	viewETRRecord = false,
	viewETRButtontext
}) => {
	/*=================================================
		General
	/================================================*/

	const { t } = useTranslation();
	const { goTo } = useNavigate();

	const { breadcrumbsItems, setBreadcrumbsItems: _setBreadcrumbsItems } =
		usePage({
			title: defaultTitle,
			breadcrumbs
		});

	function backBtnClicked() {
		goTo(nextLocation);
	}

	return (
		<div className="layout-feedback">
			<div className="layout-feedback__header">
				{translationCheck ? t(layoutHeaderTxt) : layoutHeaderTxt}
			</div>
			<div className={"etr-maker-checker__layout-feedback__subheader"}>
				{translationCheck ? t(layoutSubHeaderTxt) : layoutSubHeaderTxt}
			</div>
			<div className="layout-feedback__content theme-success">
				<SuccessLayoutSvg />
			</div>
			<div className="etr-layout-feedback__footer">
				{viewETRRecord && <>
					<Button
						text={viewETRButtontext ?? "View Record"}
						full
						noborder
						round
						maxWidth="154"
						submit={() => goTo(viewRecordLocation)}
					/>
					<span style={{ width: rem(32), display: 'inline-block' }}></span>
				</>}
				<Button
					sizing="Medium"
					text={translationCheck ? t(backBtnTxt) : backBtnTxt}
					full
					round
					maxWidth="192"
					submit={backBtnClicked}
				/>
			</div>
		</div>
	);
};

ResultPage.propTypes = {
	defaultTitle: PropTypes.string,
	breadcrumbs: PropTypes.array,
	layoutHeaderTxt: PropTypes.string,
	layoutSubHeaderTxt: PropTypes.string,
	backBtnTxt: PropTypes.string,
	nextLocation: PropTypes.any,
	translationCheck: PropTypes.bool,
	viewRecordLocation: PropTypes.any,
	viewETRRecord: PropTypes.bool,
	viewETRButtontext: PropTypes.string
};

export default ResultPage;
